module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/rikuz/rikuz.component.css
// module id = ./src/app/admin/rikuz/rikuz.component.css
// module chunks = main